import { LangHelper, SessionHelper } from "@jnpmedi/helper-session";

export const sessionHelper = new SessionHelper({ stage: process.env.REACT_APP_STAGE! });
export const langHelper = new LangHelper({ stage: process.env.REACT_APP_STAGE! });
